import React, { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Navigation from './Navigation';
import styles from './Layout.module.css';

// 不显示导航栏的路由前缀（专注学习 / 登录注册页面）
const NO_NAV_PREFIXES = ['/wordstudy', '/learn/', '/login', '/register'];
// 仅在移动端隐藏导航栏的路由前缀（阅读器页面）
const MOBILE_NO_NAV_PREFIXES = ['/read'];

const Layout = ({ children }) => {
  const location = useLocation();
  console.log('[Layout] render, path:', location.pathname, 'search:', location.search);
  const [isDesktop, setIsDesktop] = useState(() => {
    if (typeof window === 'undefined') {
      return false;
    }
    return window.innerWidth >= 1024;
  });

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 1024);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  const shouldShowNavigation = useMemo(() => {
    const path = location.pathname;
    
    for (const prefix of NO_NAV_PREFIXES) {
      if (path.startsWith(prefix)) {
        return false;
      }
    }

    if (!isDesktop) {
      for (const prefix of MOBILE_NO_NAV_PREFIXES) {
        if (path.startsWith(prefix)) {
          return false;
        }
      }
    }
    
    return true;
  }, [location.pathname, isDesktop]);
  
  return (
    <div className={styles.layout}>
      <main className={`${styles.layoutMain} ${shouldShowNavigation ? styles.withNavigation : styles.withoutNavigation}`}>
        <div className={styles.container}>
          {children}
        </div>
      </main>
      
      {shouldShowNavigation && <Navigation />}
    </div>
  );
};

export default Layout;
